module.exports = "<div class=\"props {{type}}\" content>\n    <div class=\"prop-img\"></div>\n    <h2 class=\"vprop-header\">{{ title }}</h2>\n    <p ng-if=\"textContent\" ng-bind-html=\"htmlContent(textContent)\"></p>\n    <p ng-if=\"!textContent\" ng-bind-html=\"text\"></p>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ../~/noop-loader!./components/xo-page-components/src/value-props/template.html
 ** module id = 207
 ** module chunks = 1
 **/